import { Template } from "./template.js";

function onewirePresureValueGetter(params) {
  const pressure = params.data.payload.Telemetry.onewireP;
  if(pressure != undefined){
    return pressure / globalConstants.pressureUnits[globalConstants.pressureUnitIndex].ratio;
  }
  return '';
}

const Info_window = {
  components: {
    "ag-grid-vue": window.agGridVue.AgGridVue,
  },
  props: {
    selected: String,
  },
  data() {
    return {
      perPage: 60,
      periodDays: 10,
      startDate: this.getRangeDate(10),
      endDate: this.getRangeDate(1),
      periods: 60,
      dataLogs: [],
      fields: [
        {
          field: "received",
          headerName: this.$t("modems.receivingTime"),
        },
        {
          field: "",
          headerName: this.$t("modems.messageReason"),
          sortable: true,
        },
        {
          field: "",
          headerName: this.$t("modems.formationTime"),
        },
        {
          field: "",
          headerName: this.$t("modems.temperature"),
        },
      ],
      dateRanges: [
        {
          label: this.$t("modems.year"),
          value: 365,
        },
        {
          label: this.$t("modems.halfYear"),
          value: 183,
        },
        {
          label: this.$t("modems.days30"),
          value: 30,
        },
        {
          label: this.$t("modems.days10"),
          value: 10,
        },
        {
          label: this.$t("modems.days2"),
          value: 2,
        },
        {
          label: this.$t("modems.day1"),
          value: 1,
        },
      ],
    };
  },

  computed: {
    locale() {
      return this.$i18n.locale;
    },
  },

  updated() {
    this.dateRanges[0].label = this.$t("modems.year");
    this.dateRanges[1].label = this.$t("modems.halfYear");
    this.dateRanges[2].label = this.$t("modems.days30");
    this.dateRanges[3].label = this.$t("modems.days10");
    this.dateRanges[4].label = this.$t("modems.days2");
    this.dateRanges[5].label = this.$t("modems.day1");
  },

  methods: {
    getRangeDate(days) {
      let date = new Date();
      date.setDate(date.getDate() - days + 1);
      return date.toISOString().slice(0, 10);
    },

    changeRange(days) {
      this.periodDays = days;
      this.startDate = this.getRangeDate(days);
      this.endDate = this.getRangeDate(1);
    },

    onDateRangeChange() {
      this.periodDays = null;
    },

    getModemLogs() {
      let periodBegin = new Date(this.startDate).getTime() / 1000;
      let periodEnd = new Date(this.endDate).getTime() / 1000 + 60 * 60 * 24;

      this.$API(
        "static_data",
        "modem_logs",
        {
          serial: this.selected,
          begin: periodBegin,
          end: periodEnd,
          periods: this.periods,
        },
        (data) => {
          data.forEach((element) => {
            element.received = new Date(
              element.received.replace(/\s/, "T") + "Z"
            ).toLocaleString("af-ZA", {
              timeZone: "Europe/Minsk",
            });

            element.payload.Telemetry.UTC = new Date(
              element.payload.Telemetry.UTC * 1000
            ).toLocaleString("af-ZA", {
              timeZone: "Europe/Minsk",
            });
          });

          this.dataLogs = data;

          this.dataLogs[0].payload.Message.UTC = new Date(
            this.dataLogs[0].payload.Message.UTC * 1000
          ).toLocaleString("af-ZA", { timeZone: "Europe/Minsk" });

          this.$emit("data-load", this.dataLogs[0].payload.Message);

          let nameFields = [];

          nameFields.push({
            field: "received",
            headerName: this.$t("modems.receivingTime"),
            resizable: true,
            width: 145,
            filter: true,
            sortable: true,
          });
          nameFields.push({
            field: "payload.Telemetry.UTC",
            headerName: this.$t("modems.formationTime"),
            resizable: true,
            width: 170,
            filter: true,
            sortable: true,
          });
          nameFields.push({
            field: "payload.Telemetry.reason",
            headerName: this.$t("modems.messageReason"),
            sortable: true,
            filter: true,
            resizable: true,
            width: 130,
          });
          nameFields.push({
            field: "payload.Telemetry.s_alarm1",
            headerName: "s_alarm1",
            sortable: true,
            filter: true,
            width: 90,
          });
          nameFields.push({
            field: "payload.Telemetry.s_alarm2",
            headerName: "s_alarm2",
            sortable: true,
            filter: true,
            width: 90,
          });

          for (let key1 in this.dataLogs[0].payload) {
            for (let key2 in this.dataLogs[0].payload[key1]) {
              if (key1 != "Message") {
                let str = "payload." + key1 + "." + key2;
                switch (key2) {
                  case "UTC":
                  case "bat":
                  case "temp":
                  case "reason":
                  case "s_alarm1":
                  case "s_alarm2":
                    break;
                  case "onewire":
                    // nameFields.push({
                    //   field: str,
                    //   headerName: this.$t("modems.onewire"),
                    //   width: 150,
                    //   resizable: false,
                    // });
                    break;
                  case "onewireP":
                    // nameFields.push({
                    //   field: str,
                    //   headerName: `${this.$t("modems.onewireP")} (${globalConstants.pressureUnits[globalConstants.pressureUnitIndex].unit})`,
                    //   width: 165,
                    //   resizable: false,
                    //   valueGetter: onewirePresureValueGetter,
                    //   valueFormatter: params => {
                    //     const value = Number(params.value);
                    //     return isNaN(value) ? '' : value.toFixed(3);
                    //   }
                    // });
                    break;
                  default:
                    nameFields.push({
                      field: str,
                      headerName: key2,
                      width: 76,
                      resizable: false,
                    });
                }
              }
            }
          };

          nameFields.push({
            field: "payload.Telemetry.onewire",
            headerName: this.$t("modems.onewire"),
            width: 150,
            resizable: false,
          });

          nameFields.push({
                      field:  "payload.Telemetry.onewireP",
                      headerName: `${this.$t("modems.onewireP")} (${globalConstants.pressureUnits[globalConstants.pressureUnitIndex].unit})`,
                      width: 165,
                      resizable: false,
                      valueGetter: onewirePresureValueGetter,
                      valueFormatter: params => {
                        const value = Number(params.value);
                        return isNaN(value) ? '' : value.toFixed(3);
                      }
                    });

          nameFields.push({
            field: "payload.Telemetry.bat",
            headerName: "bat",
            width: 45,
          });
          nameFields.push({
            field: "payload.Telemetry.temp",
            headerName: this.$t("modems.temperature"),
            width: 100,
          });

          this.fields = nameFields;
        },
        function () {}
      );
    },
  },
  watch: {
    locale() {
      this.getModemLogs();
    },
    selected: {
      handler: function () {
        this.getModemLogs();
      },

      immediate: true,
    },
    startDate() {
      this.getModemLogs();
    },
    endDate() {
      this.getModemLogs();
    },
  },
  template: Template,
};

export { Info_window };



// WEBPACK FOOTER //
// ./src/app/js/components/page2_modems/info_window/component.js